import { Trash2 } from 'lucide-react';

interface LmsDeleteMenuItemProps {
  /** Click handler for the menu item (e.g. open the delete-confirm dialog and close the dropdown). */
  onClick: () => void;
}

/**
 * Red "Delete" action row used at the bottom of the LMS dropdown action menus
 * (Content modules, Journeys, Sessions). Markup is identical across those pages;
 * only the click handler varies, so it is passed in verbatim by each call site.
 */
export default function LmsDeleteMenuItem({ onClick }: LmsDeleteMenuItemProps) {
  return (
    <button
      onClick={onClick}
      className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 transition-colors flex items-center gap-2"
    >
      <Trash2 className="w-4 h-4" />
      Delete
    </button>
  );
}
